import angular from 'angular';
import { LoremIpsum } from 'lorem-ipsum';
import template from './name.html';
import Repre from '~/scripts/services/model/repre';

const nameConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('name', {
		title:                  'Name',
		template,
		group:                  'advanced',
		children:               false,
		selectable:             true,
		settings:               {
			disabled:  false,
			label:     'Name',
			hideLabel: false,
			input:     false,
			kdata:     {
				path: [],
			},
			langs:     [],
			tableView: false,
			hidden:    false,
			validate:  {
				card: '0-1',
			},
		},
		icon:                   'fa fa-tags',
		views:                  [
			{
				name:     'Display',
				template: 'kform/components/name/display.html',
			},
			{
				name:     'API',
				template: 'kform/components/name/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
		onEdit: /* @ngInject */ (
			/** @type {any} */ $scope,
			/** @type {import('angular').ITimeoutService} */ $timeout,
			/** @type {import('angular').translate.ITranslateService} */ $translate,
			/** @type {any} */ Notification,
		) => {
			$scope.tmp.name = {
				kid:         undefined,
				name:        undefined,
				displayLang: true,
			};

			$scope.langKid = $scope.class_kid;

			$scope.addLang = () => {
				if ($scope.component.langs.some((/** @type {any} */ l) => l.kid === $scope.tmp.name.kid)) {
					Notification.error({
						title:   $translate.instant('error.title'),
						message: $translate.instant('error.repre-already-exists'),
					});
				}
				else {
					$scope.component.langs.push({ ...$scope.tmp.name });
					$timeout(() => {
						$scope.tmp.name.kid = undefined;
						$scope.tmp.name.name = undefined;
						$scope.tmp.name.displayLang = true;
					});
				}
			};

			$scope.setLang = async (/** @type {any} */ item, /** @type {any} */ objectName) => {
				if (item?.name) {
					objectName.name = item.name;
				}
			};
		},
		controller: /* @ngInject */ (
			/** @type {any} */ $scope,
			/** @type {import('angular').ITimeoutService} */ $timeout,
			/** @type {import('angular').translate.ITranslateService} */ $translate,
			/** @type {any} */ KTranslate,
		) => {
			if ($scope.builder) {
				const demoRepre = () => {
					const nbSamples = 2;

					$timeout(() => {
						const lorem = new LoremIpsum({ wordsPerSentence: { min: 1, max: 3 } });

						if (!Array.isArray($scope.data[$scope.component.key])) {
							$scope.data[$scope.component.key] = [];
						}
						$scope.data[$scope.component.key].length = 0;

						for (let n = 0; n < nbSamples; n++) {
							const repre = $scope.component.langs.map((/** @type {string} */ lang) => (new Repre({
								lang,
								type:  'K_NODE;STRING',
								value: lorem.generateWords(1),
							})));
							$scope.data[$scope.component.key].push({
								kid: `K_NODE;${lorem.generateWords(1).toUpperCase()}`,
								repre,
							});
						}
					});
				};

				$timeout(() => {
					if ($scope.component.langs.length === 0) {
						$scope.component.langs.push({
							kid:         'K_NODE;UNIVERSEL',
							name:        $translate.instant('common.name'),
							displayLang: false,
						});
					}
				});

				$scope.$watch('component.langs', demoRepre, true);

				// Automatically sets label and langs according to the path
				$scope.$watch('component.kdata.path', async (/** @type {any[]}} */ path) => {
					if (Array.isArray(path) && path.length > 0) {
						const lastPathItem = path.at(-1);
						$scope.$parent.langKid = lastPathItem.kid;
						if (!lastPathItem.name) {
							lastPathItem.name = await KTranslate.request($scope, lastPathItem.kid);
						}
						$timeout(() => {
							$scope.component.label = lastPathItem.name;
						});
					}
				}, true);
			}
		},
	});
};

export default angular.module('app').config(nameConfig);
